import FadeOut from './FadeOut'

export default FadeOut
